
import React from 'react'
//import React,{useState} from 'react'

export default function About(props) {
    // const [DarkOrWot, setDark] = useState({
    //     color: '#15f4ee',
    //     background: 'black'
    // })
     
    //  let SemiDark = {
    //     color: 'black',
    //     background: 'grey'
    // }
    return (
        //<div classNameNameName='container' style={DarkOrWot}> 
        <div classNameName="container" style={{backgroundcolour: props.mode==='dark'? 'grey': 'white',color: props.mode=== 'dark'?'grey':'black'}} > 
        <div classNameName="container" style={{backgroundcolour: props.mode==='dark'? 'grey': 'white',color: props.mode=== 'dark'?'grey':'black'}}>
            {/* <h1 style={{backgroundcolour: props.mode==='dark'? 'grey': 'white',color: props.mode=== 'dark'?'grey':'black'}}>More Info🔎</h1> */}
            <div className="accordion accordion-flush" id="accordionFlushExample" style={{backgroundcolour: props.mode==='dark'? 'grey': 'white',color: props.mode=== 'dark'?'grey':'black'}}>
                <div className="accordion-item ">
                    <h2 className="accordion-header" id="flush-headingOne" >
                        <button className="accordion-button collapsed"  type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                            What is eSKMIo? 🕵️‍♀️
                        </button>
                    </h2>
                    <div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                        <div className="accordion-body">eSKIMo🧊 is a software which <code>labells</code> texts according to the inference, after <code>skimming</code> them into subparts.  </div>
                    </div>
                </div>
                <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingTwo">
                        <button className="accordion-button collapsed"  type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                            How does it skim and labelize your text? 📜
                        </button>
                    </h2>
                    <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                        <div className="accordion-body">It is a Machine Learning model developed using <code>TensorFlow</code>, a library in Python. I would encourage you to checkout the Readme file of the project for more information about all the magic that happens at the backend🧙‍♂️</div>
                    </div> 
                </div>
                <div className="accordion-item ">
                    <h2 className="accordion-header" id="flush-headingThree">
                        <button className="accordion-button collapsed" type="button"  data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                            Feel free to contribute and suggestions for filling out the spaces I may have missed.🌴
                        </button>
                    </h2>
                    <div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                        <div className="accordion-body">You can checkout the GitHub link in the About section of the Navigation bar.</div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    )
}
